module.exports = __webpack_public_path__ + "static/media/Take You Anyway.6914f36f.jpg";